import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  FormControlLabel,
  TextField,
  Paper,
  Radio,
  Input,
  FormHelperText,
} from "@material-ui/core";
import ReactSelect from 'react-select';
import TabPanel from "./TabPanel";
import { FormField, TextFieldWithError } from '../components';
import { useStyles } from './StartPageSettings';
import AddImage from '../components/AddImage'
import ElementIcon from "../../../common/icon/ElementIcon";
import clsx from 'clsx';
import SwitchBtn from '../../../components/SwitchBtn';

const propTypes = {
  activeTab: PropTypes.number.isRequired,
  use_end_page_html: PropTypes.bool,
  setUseEndPageHtml: PropTypes.func.isRequired,
  use_confirm_page: PropTypes.bool,
  setUseConfirmPage: PropTypes.func.isRequired,
  use_redirect: PropTypes.bool.isRequired,
  setUseRedirect: PropTypes.func.isRequired,
  redirect_url: PropTypes.string,
  setRedirectUrl: PropTypes.func.isRequired,
  end_page_main_image: PropTypes.object,
  onLoadEndPageMainImage: PropTypes.func.isRequired,
  onDeleteEndPageMainImage: PropTypes.func.isRequired,
  end_page_main_text: PropTypes.string,
  setEndPageMainText: PropTypes.func.isRequired,
  end_page_html: PropTypes.string,
  setEndPageHtml: PropTypes.func.isRequired,
  end_page_custom_css: PropTypes.string,
  setEndPageCustomCss: PropTypes.func.isRequired,
  high_rating_end_page_html: PropTypes.string,
  setHighRatingEndPageHtml: PropTypes.func.isRequired,
  high_rating_end_page_custom_css: PropTypes.string,
  setHighRatingEndPageCustomCss: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired,
  onSaveAndPreviewEndPage: PropTypes.func,
  onSaveAndPreviewHighRatingEndPage: PropTypes.func,
  use_google_review: PropTypes.bool,
  setUseGoogleReview: PropTypes.func.isRequired,
  google_review_min_score: PropTypes.number,
  setGoogleReviewMinScore: PropTypes.func.isRequired,
  hasNpsQuestion: PropTypes.bool.isRequired,
};

const EndPageSettings = ({
  activeTab,
  use_end_page_html,
  setUseEndPageHtml,
  use_confirm_page,
  setUseConfirmPage,
  use_redirect,
  setUseRedirect,
  redirect_url,
  setRedirectUrl,
  end_page_main_image,
  onLoadEndPageMainImage,
  onDeleteEndPageMainImage,
  end_page_main_text,
  setEndPageMainText,
  end_page_html,
  setEndPageHtml,
  end_page_custom_css,
  setEndPageCustomCss,
  high_rating_end_page_html,
  setHighRatingEndPageHtml,
  high_rating_end_page_custom_css,
  setHighRatingEndPageCustomCss,
  errors,
  survey,
  onSaveAndPreviewEndPage,
  onSaveAndPreviewHighRatingEndPage,
  use_google_review,
  setUseGoogleReview,
  google_review_min_score,
  setGoogleReviewMinScore,
  hasNpsQuestion,
}) => {
  const classes = useStyles();

  const handlePreviewEndPage = () => {
    if (onSaveAndPreviewEndPage) {
      onSaveAndPreviewEndPage();
    } else if (survey && survey.company_uid && survey.url_string) {
      const previewUrl = `/s/preview/${survey.company_uid}/${survey.url_string}?endpage=true`;
      window.open(previewUrl, '_blank');
    }
  };

  const handlePreviewHighRatingEndPage = () => {
    if (!use_end_page_html) {
      return;
    }

    if (onSaveAndPreviewHighRatingEndPage) {
      onSaveAndPreviewHighRatingEndPage();
    } else if (survey && survey.company_uid && survey.url_string) {
      const previewUrl = `/s/preview/${survey.company_uid}/${survey.url_string}?endpage=true&preview_mode=high`;
      window.open(previewUrl, '_blank');
    }
  };

  return (
    <TabPanel value={activeTab} index={3}>
      <div className={classes.root}>

        <div className={classes.radioGroup}>
          <FormGroup className={classes.button}>
            <FormControlLabel
              control={
                <Radio
                  checked={use_end_page_html}
                  onClick={() => setUseEndPageHtml(!use_end_page_html)}
                />
              }
              name="use_end_page_html"
              label="HTMLを使用"
            />
          </FormGroup>
          <FormGroup className={classes.button}>
            <FormControlLabel
              control={
                <Radio
                  checked={use_confirm_page}
                  onClick={() => setUseConfirmPage(!use_confirm_page)}
                />
              }
              name="use_confirm_page"
              label="確認ページを使用"
            />
          </FormGroup>
          <FormGroup className={classes.button}>
            <FormControlLabel
              control={
                <Radio
                  checked={use_redirect}
                  onClick={() => setUseRedirect(!use_redirect)}
                />
              }
              name="use_redirect"
              label="終了ページをリダイレクト"
            />
          </FormGroup>
          <div
            onClick={handlePreviewEndPage}
            className={classes.endPagePreview}
          >
            <i className="fa fa-external-link" style={{ marginRight: '8px' }} aria-hidden="true"></i>
            終了ページプレビュー
          </div>
          {use_end_page_html && (
            <div
              onClick={handlePreviewHighRatingEndPage}
              className={classes.endPagePreview}
              style={{ marginLeft: 10 }}
            >
              <i className="fa fa-external-link" style={{ marginRight: '8px' }} aria-hidden="true"></i>
              終了ページプレビュー（高評価用）
            </div>
          )}
        </div>

        {!use_redirect && !use_end_page_html &&
          <AddImage
            image={end_page_main_image}
            setImage={onLoadEndPageMainImage}
            onDelete={onDeleteEndPageMainImage}
          />
        }

        {!use_redirect ?
          <Paper className={classes.form}>
            {!use_end_page_html ?
              <FormField component="fieldset" fullWidth className={classes.htmlInput}>
                <Input
                  placeholder="ここにメインテキストを書いてください。"
                  fullWidth
                  name="end_page_main_text"
                  multiline
                  classes={{
                    input: classes.input,
                  }}
                  endAdornment={<ElementIcon name='edit-outline' className={classes.editIcon} />}
                  defaultValue={end_page_main_text}
                  onChange={e => setEndPageMainText(e.target.value)}
                />
              </FormField>
            :
              <FormField component="fieldset" label={"HTML入力エリア"} fullWidth className={clsx(classes.formInput, classes.textField)} error={!!errors.end_page_html}>
                <TextField
                  name="end_page_html"
                  placeholder="HTML入力エリア"
                  multiline
                  rows={10}
                  variant="outlined"
                  helperText="以下のタグが利用可能です。 h3, h4, h5, h6, blockquote, p, a, ul, ol, nl, li, b, i, strong, em, strike, code, hr, br, div, table, thead, caption, tbody, tr, th, td, pre, iframe"
                  defaultValue={end_page_html}
                  onChange={e => setEndPageHtml(e.target.value)}
                />
              </FormField>
            }

            <FormField className={clsx(classes.formInput, classes.textField)} component="fieldset" fullWidth label={"カスタムCSS"}>
              <TextField
                name="end_page_custom_css"
                placeholder="CSSを入力ください。"
                multiline
                rows={10}
                variant="outlined"
                defaultValue={end_page_custom_css}
                onChange={e => setEndPageCustomCss(e.target.value)}
              />
            </FormField>
          </Paper>
        :
          <Paper className={classes.form}>
            <FormField className={clsx(classes.formInputURL, classes.textField)} component="fieldset" fullWidth label={"リダイレクトURL"} error={!!errors.redirect_url}>
              <TextFieldWithError
                name="redirect_url"
                placeholder="リダイレクトURLを入力してください"
                rows={1}
                variant="outlined"
                helperText="例）https://some.url/with/param?shop_id=<%=shop_id=%>&staff_id=<%=staff_id=%>"
                defaultValue={redirect_url}
                onChange={e => setRedirectUrl(e.target.value)}
                type={"url"}
                errors={errors.redirect_url}
              />
              {!!errors.redirect_url && (
                <FormHelperText>{`リダイレクトURL${errors.redirect_url}`}</FormHelperText>
              )}
            </FormField>

            <b>URL内で以下のタグが使用可能です。</b>
            <ul>
              <li>店舗ID &lt;%=shop_id=%&gt;</li>
              <li>担当スタッフID &lt;%=staff_id=%&gt;</li>
              <li>レジID &lt;%=pos_id=%&gt;</li>
              <li>購入日 &lt;%=purchase_date=%&gt;</li>
              <li>取引ID &lt;%=deal_id=%&gt;</li>
              <li>顧客ID &lt;%=customer_id=%&gt;</li>
              <li>カスタム１ &lt;%=custom01=%&gt;</li>
              <li>カスタム２ &lt;%=custom02=%&gt;</li>
            </ul>
          </Paper>
        }
        {!use_redirect && hasNpsQuestion && use_end_page_html && (
          <>
            <FormField className={clsx(classes.formInput)} component="fieldset" fullWidth label={"Google マップ口コミ遷移機能"}>
              <SwitchBtn
                checked={!!use_google_review}
                onChange={e => setUseGoogleReview(e.target.checked)}
              />
            </FormField>
            {use_google_review && (
              <FormField className={clsx(classes.formInput)} component="fieldset" fullWidth label={"NPS設問の点数"}>
                <div style={{ width: 265 }}>
                  <ReactSelect
                    placeholder="0-10まで選択"
                    isSearchable={false}
                    value={google_review_min_score != null ? { value: google_review_min_score, label: String(google_review_min_score) } : null}
                    onChange={option => setGoogleReviewMinScore(option ? option.value : null)}
                    options={[...Array(11).keys()].map(score => ({ value: score, label: String(score) }))}
                    theme={theme => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#EC681A',
                        primary25: '#ffcf86',
                        primary50: '#ffcf86',
                      },
                    })}
                  />
                </div>
              </FormField>
            )}
          </>
        )}
        {!use_redirect && !!use_google_review && use_end_page_html && (
          <>
            <div style={{ margin: '20px 0 10px', fontWeight: 'bold' }}>
              高評価時終了ページ
            </div>
            <Paper className={classes.form}>
              <FormField component="fieldset" label={"高評価時終了ページ用HTML入力エリア"} fullWidth className={clsx(classes.formInput, classes.textField)} error={!!errors.high_rating_end_page_html}>
                <TextField
                  name="high_rating_end_page_html"
                  placeholder="高評価時終了ページ用HTML入力エリア"
                  multiline
                  rows={10}
                  variant="outlined"
                  helperText={<>
                    以下のタグが利用可能です。<br />
                    h3, h4, h5, h6, blockquote, p, a, ul, ol, nl, li, b, i, strong, em, strike, code, hr, br, div, table, thead, caption, tbody, tr, th, td, pre, iframe<br />
                    <br />
                    利用可能なパーツ名<br />
                    {'{%NPS_REASON_TEXTAREA%}'} = NPS理由を表示するテキストエリア(編集可能)<br />
                    {'{%COPY_BUTTON%}'} = コピーアイコンのみのボタン<br />
                    {'{%COPY_BUTTON:回答内容をコピー%}'} = 任意文言のコピー用ボタン<br />
                    {'{%GMB_LINK%}'} = Googleマップ口コミURLをリンク付きでそのまま表示<br />
                    {'{%GMB_URL%}'} = Googleマップ口コミURLの値のみ差し込み。リンク文言はHTML側で自由に指定可能
                  </>}
                  defaultValue={high_rating_end_page_html}
                  onChange={e => setHighRatingEndPageHtml(e.target.value)}
                />
              </FormField>
              <FormField className={clsx(classes.formInput, classes.textField)} component="fieldset" fullWidth label={"高評価時終了ページ用カスタムCSS"}>
                <TextField
                  name="high_rating_end_page_custom_css"
                  placeholder="CSSを入力ください。"
                  multiline
                  rows={10}
                  variant="outlined"
                  defaultValue={high_rating_end_page_custom_css}
                  onChange={e => setHighRatingEndPageCustomCss(e.target.value)}
                />
              </FormField>
            </Paper>
          </>
        )}
      </div>
    </TabPanel>
  );
}

EndPageSettings.propTypes = propTypes;

export default EndPageSettings;
